<script>
export default {
  props: {
  },
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.list = [
        {
          img: require('@index/assets/img/homepage/homepage_banner1.jpg'),
          url: '/viewerpdf/68'
        }
        // {
        //   img: 'https://trends.zhiweidata.com/hotSearchTrend/mainBanner/getMainBannerImage?Id=643f88c74248200001a1d86e',
        //   url: 'https://www.baidu.com'
        // }
      ]
      // getMainBannerList().then(res => {
      //   if (res.state) {
      //     this.list = res.data
      //   }
      //   console.log(res)
      // })
    },
    openHref (url) {
      if (url) {
        this.$router.push(url)
      }
    }
  }
}
</script>
<template>
  <div class='carousel'>
    <el-carousel
      :interval="5000"
      height="150px"
    >
      <el-carousel-item
        v-for="(item, i) in list"
        :key="i"
      >
        <img
          :src="item.img"
          style="width:100%;"
          @click="openHref(item.url)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style lang='scss' scoped>
.carousel {
  width: 100%;

  .banner-img {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/components/CarouselBanner.vue